"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partitionResults = partitionResults;
const utils_1 = require("./utils");
const isResultArray = (array) => array.every(item => (item && "data" in item && "error" in item));
const isPromiseResultArray = (array) => array.every(utils_1.isPromise);
/**
 * @desc Takes in an array of Results, an array of promises of results, or a promise of an
 * array of results, and returns an object with a data property containing an array of all
 * the data from the results, and an errors property containing an AggregateError if there
 * were multiple errors, a single error if there was only one, or null if there were no
 * errors.
 */
function partitionResults(results) {
    const processResults = (results) => {
        const data = [];
        const errors = [];
        for (const result of results) {
            if (result.error) {
                errors.push(result.error);
            }
            else {
                data.push(result.data);
            }
        }
        let partitionedErrors = null;
        if (errors.length > 1) {
            partitionedErrors = new AggregateError(errors);
        }
        else if (errors.length > 0) {
            partitionedErrors = errors[0];
        }
        return {
            data,
            errors: partitionedErrors
        };
    };
    // Check if results is a Promise
    if ((0, utils_1.isPromise)(results)) {
        return results.then(resolvedResults => {
            // Handle Promise<Result<T, E>[]>
            if (Array.isArray(resolvedResults)) {
                return processResults(resolvedResults);
            }
            else {
                return Promise.all(resolvedResults).then(processResults);
            }
        });
    }
    else if (Array.isArray(results)) { // Check if results is a Promise[]
        if (isResultArray(results)) {
            // Handle Result<T, E>[]
            return processResults(results);
        }
        else if (isPromiseResultArray(results)) {
            // Handle Promise<Result<T, E>>[]
            return Promise.all(results).then(processResults);
        }
    }
    // Handle Result<T, E>[]
    return processResults(results);
}
